/* World Spice 2026 — recently viewed rail.

   Same mechanism as the stock recently-viewed-products.js: the browsing history
   is a list of product ids in localStorage, written by the theme on every
   product view. Rendering sections/ws-recently-viewed.liquid through the search
   endpoint with an `id:a OR id:b` query is what turns those ids into products.

   Kept separate from the stock script because that one removes the section
   unless it finds a `.product-card` — the old theme's card class, which the
   redesign's .pcard cards deliberately do not carry. */
if (!customElements.get('ws-recently-viewed')) {
  customElements.define(
    'ws-recently-viewed',
    class WsRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.load.bind(this), { timeout: 1500 });
        } else {
          setTimeout(this.load.bind(this), 500);
        }
      }

      load() {
        const url = this.queryUrl();
        if (!url) {
          this.remove();
          return;
        }

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const fetched = parsed.querySelector('ws-recently-viewed');
            if (!fetched || !fetched.querySelector('.pcard')) {
              this.remove();
              return;
            }

            this.innerHTML = fetched.innerHTML;
            this.querySelector('.ws-rv')?.removeAttribute('hidden');
            // The tin labels shrink their own type to fit; these arrived after
            // the load event that normally triggers that.
            if (window.wsFitWords) window.wsFitWords(this);
          })
          .catch(() => this.remove());
      }

      queryUrl() {
        let items;
        try {
          items = JSON.parse(window.localStorage.getItem('sleektheme:recently-viewed') || '[]');
        } catch (e) {
          return false;
        }
        if (!Array.isArray(items) || !items.length) return false;

        const productId = parseInt(this.dataset.productId, 10);
        const limit = parseInt(this.dataset.productsToShow, 10) || 8;
        const ids = items.filter((id) => id !== productId).slice(0, limit);
        if (!ids.length) return false;

        return this.dataset.url + ids.map((id) => 'id:' + id).join(' OR ');
      }
    }
  );
}
